import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const insertCustomModule = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCustomModuleById = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModule = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleId = async (moduleId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}/${moduleId}/${pageId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCustomModuleLibrary = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}`, {
      data: { libIds: ids },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const insertCustomModuleGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleGroup = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleGroupId = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCustomModuleGroupById = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCustomModuleGroup = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, {
      data: { groupIds: ids },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addLibraryToCustomModuleGroup = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateCustomModuleLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.DUPLICATE_CUSTOM_MODULE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async () => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.CUSTOM_MODULE.DOWNLOAD_CUSTOM_TABLE_SAMPLE}`, null, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const activeInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_STATUS}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadCMImageS3 = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.UPLOAD_CM_IMAGE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCMImageFromS3 = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CM_IMAGE_DELETE}`, { data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNewPageId = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.GET_NEW_PAGEID}`, { ...data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteCustomModuleLibraryPage = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.DELETE_PAGE_ID}`, {
      data: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleList = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_LIST}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateLibraryPageSequence = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_REARRANGE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleContentPage = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_CONTENT_PAGE}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// pageId Controls
export const getPageControls = async (customModuleLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_CONTROLS}/${customModuleLibId}/${pageId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};
// pageId Controls
export const getSrcPages = async (customModuleLibId, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGES}/${customModuleLibId}`, { params: { ...params } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// get all depenednt controls
export const getDependentControlsList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_DEPENDENT_CONTROLS}/${data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleContentData = async (moduleId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_CONTENT_DATA}/${moduleId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
// calculation pageId Controls
export const getPageCalculationControls = async (customModuleLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_CALCULATION_CONTROLS}/${customModuleLibId}/${pageId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const previewTemplateService = async (data) => {
  console.log('🚀 ~ previewTemplateService ~ data:', data);
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.PREVIEW_CUSTOM_MODULE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInactiveCustomModuleGroup = async (data) => {
  try {
    const res = await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP_STATUS}`, data);
    if (res.code === 200) {
      return res;
    }
    return false;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
